module.exports = __WEBPACK_EXTERNAL_MODULE_3__;


//////////////////
// WEBPACK FOOTER
// external {"root":"_","commonjs2":"lodash","commonjs":"lodash","amd":"lodash"}
// module id = 3
// module chunks = 0